export default __webpack_public_path__ + "static/media/09.24e9cbc8.png";